export default "__VITE_ASSET__CcDrxUrR__"